import React, { Component } from 'react';
import { Container, Row, Col, Navbar } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
        <Container tag="main" fluid>
            <Navbar expand="md">
                <NavMenu />
            </Navbar>
            {this.props.children}
          </Container>


    );
  }
}
